<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
         <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>考试详情列表</span>
        </div>
      </div>
        <!-- <div class="pagetitle">考试详情筛�</div>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline searchform"
        >
          <div class="flex mar_t20 ">
            <el-form-item label="考试类型">
              <el-select
                v-model="formInline.vipLabel"
                :placeholder="$t('common.pleaseSelect')"
                @change="onSearch"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="骑手姓名" class="mar_l20">
              <el-input
                v-model="formInline.keyword"
                size="medium"
                :placeholder="$t('rider.list.namePh')" @input="onSearch"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch" size="medium"
                >{{ $t('common.filter') }}</el-button
              >
            </el-form-item> -->
          <!-- </div>
        </el-form> -->
      </div>
      <div class="ba_f pad_20">
        <div class="pagetitle mar_b20">考试详情列表</div>
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学习列表" name="1">
               
        </el-tab-pane>
         <el-tab-pane label="题目列表" name="2">
               
        </el-tab-pane>
    </el-tabs> -->
   
        <el-table
          v-loading="listLoading"
          :element-loading-text="loadingText"
          :data="list"
          stripe
          style="width: 100%"
          @selection-change="setSelectRows"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- <el-table-column prop="id" label="ID"> </el-table-column> -->
          <el-table-column prop="userName" label="骑手" >
          </el-table-column>
          <el-table-column prop="portrait" label="头像"> 
            <template slot-scope="scope">
                <div class="imgbox"><img :src="scope.row.portrait" class="tabimg" /></div>
              </template>
          </el-table-column>
           <!-- <el-table-column prop="title" label="得分"> </el-table-column> -->
            <el-table-column prop="typeName" label="考试类别"> </el-table-column>
          <el-table-column prop="createdAt" label="考试时间"> </el-table-column>
         
         
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="page.total"
          :page-size="page.pagesize"
          :current-page.sync="page.currentPage"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
       
      
      </div>
    </div>
  
       
  </div>
</template>
<script>
 import {collegeDetail} from '@/api/plugins'
export default {

  data() {
    return {
   
    list:[],
      formInline: {
        keyword: "",
        vipLabel: "",
        isBlack: "",
        userChannel: "",
        timeData: ""
      },
 
      activeName:'2',
      listLoading:true,
      
      options2: [
        {
          value: "0",
          label: "全部"
        },
        {
          value: "1",
          label: "外卖商家"
        },
        {
          value: "2",
          label: "跑腿商家"
        }
      ],
     
      // listLoading: true,
      selectRows: "",
      
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  created(){
    this.fetchData();
  },
  computed: {

    loadingText() {

      return this.$t('common.loading');

    },

  },

  methods: {
    handleClose(){
      this.dialogVisible=false;  
    },
    onSearch(){},
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleEdit(row) {
      if (row.id) {
        this.$refs["edit"].showEdit(row);
      } else {
        this.$refs["edit"].showEdit();
      }
     
    },
   async fetchData(){
      var params={page:this.page.currentPage};
         const { data, count } = await collegeDetail(params);
        this.list = data;
        this.page.total = count;
        this.listLoading = false;
    },
    
     handleCurrentChange(val) {
        this.page.currentPage = val;
         this.fetchData();     
    },
  }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper .el-form-item__content .el-input {
    width: 200px;
    margin-right: 15px;
}

</style>